// @ts-nocheck
  (function () {
    var scriptEl = document.currentScript || document.querySelector('script[data-cc-child-collection-script][data-section-id]');
    var SID = scriptEl && scriptEl.dataset ? scriptEl.dataset.sectionId : null;
    var currency_symbol = scriptEl && scriptEl.dataset ? (scriptEl.dataset.currencySymbol || '') : '';
    var sectionRoot = SID ? document.querySelector('[data-cc-child-collection][data-section-id=\"' + SID + '\"]') : null;
    if (!sectionRoot) sectionRoot = document;
    if (!SID) return;

    var defaultSort = sectionRoot.dataset.defaultSort || 'featured';
    var state = {
      sort: defaultSort,
      sizes: [],
      colors: [],
      intents: [],
      priceRanges: [],
      onSale: false,
      discountRanges: [],
    };

    function syncStateFromDOM() {
      var sectionWrap = grid ? grid.closest('.cc-page') : document;
      var sortRadio = sectionWrap.querySelector('[data-sort]:checked');
      if (sortRadio) state.sort = sortRadio.value;

      state.sizes = Array.from(sectionWrap.querySelectorAll('[data-filter-type="size"]:checked')).map(function (cb) { return cb.value; });
      state.colors = Array.from(sectionWrap.querySelectorAll('[data-filter-type="color"]:checked')).map(function (cb) { return cb.value; });
      state.intents = Array.from(sectionWrap.querySelectorAll('[data-filter-type="intent"]:checked')).map(function (cb) { return cb.value; });
      state.priceRanges = Array.from(sectionWrap.querySelectorAll('[data-filter-type="price-range"]:checked')).map(function (cb) { return cb.value; });
      state.onSale = !!sectionWrap.querySelector('[data-filter-type="on-sale"]:checked');
      state.discountRanges = Array.from(sectionWrap.querySelectorAll('[data-filter-type="discount-range"]:checked')).map(function (cb) { return cb.value; });
    }

    function syncStateFromURL() {
      var params = new URLSearchParams(window.location.search);
      var sectionWrap = grid ? grid.closest('.cc-page') : document;

      // Sort
      var urlSort = params.get('sort');
      if (urlSort) {
        state.sort = urlSort;
        var radio = sectionWrap.querySelector('[data-sort][value="' + urlSort + '"]');
        if (radio) radio.checked = true;
      }

      // Sizes
      var urlSizes = params.get('size');
      if (urlSizes) {
        state.sizes = urlSizes.split(',');
        sectionWrap.querySelectorAll('[data-filter-type="size"]').forEach(function (cb) {
          cb.checked = state.sizes.indexOf(cb.value) > -1;
        });
      }

      // Colors
      var urlColors = params.get('color');
      if (urlColors) {
        state.colors = urlColors.split(',');
        sectionWrap.querySelectorAll('[data-filter-type="color"]').forEach(function (cb) {
          cb.checked = state.colors.indexOf(cb.value) > -1;
        });
      }

      // Executive desk buyer intent
      var urlIntents = params.get('desk_type');
      if (urlIntents) {
        state.intents = urlIntents.split(',');
        sectionWrap.querySelectorAll('[data-filter-type="intent"]').forEach(function (cb) {
          cb.checked = state.intents.indexOf(cb.value) > -1;
        });
      }

      // Price Ranges
      var urlPrice = params.get('price');
      if (urlPrice) {
        state.priceRanges = urlPrice.split(',');
        sectionWrap.querySelectorAll('[data-filter-type="price-range"]').forEach(function (cb) {
          cb.checked = state.priceRanges.indexOf(cb.value) > -1;
        });
      }

      // Offers
      var urlOnSale = params.get('on_sale');
      if (urlOnSale) {
        state.onSale = urlOnSale === 'true';
        var onSaleCb = sectionWrap.querySelector('[data-filter-type="on-sale"]');
        if (onSaleCb) onSaleCb.checked = state.onSale;
      }

      var urlDiscount = params.get('discount');
      if (urlDiscount) {
        state.discountRanges = urlDiscount.split(',');
        sectionWrap.querySelectorAll('[data-filter-type="discount-range"]').forEach(function (cb) {
          cb.checked = state.discountRanges.indexOf(cb.value) > -1;
        });
      }
    }

    function updateURL() {
      var params = new URLSearchParams(window.location.search);

      if (state.sort && state.sort !== defaultSort) params.set('sort', state.sort);
      else params.delete('sort');

      if (state.sizes.length > 0) params.set('size', state.sizes.join(','));
      else params.delete('size');

      if (state.colors.length > 0) params.set('color', state.colors.join(','));
      else params.delete('color');

      if (state.intents.length > 0) params.set('desk_type', state.intents.join(','));
      else params.delete('desk_type');

      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      if (state.priceRanges.length > 0) {
        params.set('price', state.priceRanges.join(','));
      } else {
        params.delete('price');
      }

      params.delete('lowest_price');

      if (state.onSale) params.set('on_sale', 'true');
      else params.delete('on_sale');

      if (state.discountRanges.length > 0) params.set('discount', state.discountRanges.join(','));
      else params.delete('discount');

      var newUrl = window.location.pathname + '?' + params.toString();
      window.history.replaceState({ path: newUrl }, '', newUrl);
    }
    /* ── DOM refs ───────────────────────────────────── */
    var grid = document.getElementById('cc-grid-' + SID);
    var emptyMsg = document.getElementById('cc-empty-' + SID);
    var resultEl = document.getElementById('cc-result-count-' + SID);
    var sidebarCountEl = document.getElementById('cc-count-' + SID);
    var activeEl = document.getElementById('cc-active-' + SID);
    var filterProgressEl = document.getElementById('cc-filter-progress-' + SID);
    var canUseNativePriceFilter = sectionRoot.dataset.aggregatesSubcollections !== 'true';
    var serverRenderedNativePriceFilter = false;

    /* Keep long SEO descriptions available without pushing products below the fold. */
    var descriptionToggle = sectionRoot.querySelector('[data-description-toggle]');
    var collectionDescription = sectionRoot.querySelector('[data-collection-description]');
    if (descriptionToggle && collectionDescription) {
      descriptionToggle.addEventListener('click', function () {
        var expanded = descriptionToggle.getAttribute('aria-expanded') === 'true';
        descriptionToggle.setAttribute('aria-expanded', String(!expanded));
        collectionDescription.classList.toggle('is-expanded', !expanded);

        var label = descriptionToggle.querySelector('[data-description-toggle-label]');
        if (label) label.textContent = expanded ? 'Read more' : 'Read less';
      });
    }

    var descriptionJump = sectionRoot.querySelector('[data-description-jump]');
    if (descriptionJump) {
      descriptionJump.addEventListener('click', function () {
        var targetId = descriptionJump.getAttribute('aria-controls');
        var target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;

        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        window.setTimeout(function () {
          target.focus({ preventScroll: true });
        }, reducedMotion ? 0 : 450);
      });
    }

    var fullDescriptionContent = sectionRoot.querySelector('[data-full-description-content]');
    var fullDescriptionToggle = sectionRoot.querySelector('[data-full-description-toggle]');
    if (fullDescriptionContent && fullDescriptionToggle) {
      var collapsedDescriptionHeight = window.innerWidth <= 600 ? 430 : 560;
      if (fullDescriptionContent.scrollHeight > collapsedDescriptionHeight + 40) {
        fullDescriptionContent.classList.add('is-collapsible');
        fullDescriptionToggle.hidden = false;

        fullDescriptionToggle.addEventListener('click', function () {
          var expanded = fullDescriptionToggle.getAttribute('aria-expanded') === 'true';
          fullDescriptionToggle.setAttribute('aria-expanded', String(!expanded));
          fullDescriptionContent.classList.toggle('is-expanded', !expanded);
          var fullLabel = fullDescriptionToggle.querySelector('[data-full-description-toggle-label]');
          if (fullLabel) fullLabel.textContent = expanded ? 'Read more' : 'Read less';

          if (expanded) {
            var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            sectionRoot.querySelector('.cc-full-desc__heading')?.scrollIntoView({
              behavior: reducedMotion ? 'auto' : 'smooth',
              block: 'start'
            });
          }
        });
      }
    }

    if (!grid) return;

    var cards = Array.from(grid.querySelectorAll('.cc-card-wrap'));
    var priceSegmentsEl = sectionRoot.querySelector('[data-price-segments]');
    var priceCatalogPromise = null;
    var catalogOrderPromise = null;
    var priceSegmentsAccurate = false;

    function formatPriceValue(value) {
      var rounded = Math.round(value);
      var formatted = rounded.toLocaleString('en-US');
      var spacer = /[A-Za-z]$/.test(currency_symbol) ? ' ' : '';
      return currency_symbol + spacer + formatted;
    }

    function getAdaptivePriceStep(maxPrice, rawStep) {
      if (maxPrice <= 5000 && rawStep <= 500) return 500;
      if (maxPrice <= 5000 && rawStep <= 1000) return 1000;
      if (maxPrice <= 5000) return 2000;
      if (maxPrice <= 10000 && rawStep <= 1000) return 1000;
      if (maxPrice <= 10000) return 2000;
      if (rawStep <= 1000) return 1000;
      if (rawStep <= 2000) return 2000;
      if (rawStep <= 2500) return 2500;
      if (rawStep <= 5000) return 5000;
      if (rawStep <= 10000) return 10000;
      if (rawStep <= 20000) return 20000;
      if (rawStep <= 25000) return 25000;
      if (rawStep <= 50000) return 50000;
      if (rawStep <= 100000) return 100000;
      return 250000;
    }

    function buildAdaptivePriceSegments(prices) {
      var sorted = prices.slice().sort(function (a, b) { return a - b; });
      if (!sorted.length) return [];

      var total = sorted.length;
      var minPrice = sorted[0];
      var maxPrice = sorted[total - 1];
      var referenceMax = maxPrice;

      if (total >= 20) {
        var p90Index = Math.min(Math.floor(total * 0.9), total - 1);
        var p90Price = sorted[p90Index];
        if (maxPrice > p90Price * 1.5) referenceMax = p90Price;
      }

      var targetCount = total < 12 ? 3 : 4;
      var rawStep = Math.max(1, Math.ceil((referenceMax - minPrice) / 4));
      var step = getAdaptivePriceStep(maxPrice, rawStep);
      var firstMax = (Math.floor(minPrice / step) + 1) * step;
      var baseRanges = [
        { min: 0, max: firstMax },
        { min: firstMax, max: firstMax + step },
        { min: firstMax + step, max: firstMax + step * 2 },
        { min: firstMax + step * 2, max: firstMax + step * 3 },
        { min: firstMax + step * 3, max: Infinity }
      ];

      baseRanges.forEach(function (range) {
        range.count = sorted.reduce(function (count, price) {
          return count + (price >= range.min && price < range.max ? 1 : 0);
        }, 0);
      });

      var populated = [];
      baseRanges.forEach(function (range, index) {
        if (range.count > 0) {
          populated.push(range);
          return;
        }
        if (index < baseRanges.length - 1) {
          baseRanges[index + 1].min = range.min;
        } else if (populated.length) {
          populated[populated.length - 1].max = Infinity;
        }
      });

      while (populated.length > targetCount) {
        var mergeIndex = 1;
        for (var i = 2; i < populated.length - 1; i += 1) {
          if (populated[i].count < populated[mergeIndex].count) mergeIndex = i;
        }
        populated[mergeIndex - 1].max = populated[mergeIndex].max;
        populated[mergeIndex - 1].count += populated[mergeIndex].count;
        populated.splice(mergeIndex, 1);
      }

      return populated;
    }

    function getPriceRangeValue(range) {
      return String(range.min) + '-' + (range.max === Infinity ? 'plus' : String(range.max));
    }

    function getPriceRangeBounds(value) {
      var parts = String(value || '').split('-');
      var min = parseFloat(parts[0]);
      var max = parts[1] === 'plus' ? Infinity : parseFloat(parts[1]);
      if (!Number.isFinite(min) || (!Number.isFinite(max) && max !== Infinity)) return null;
      return { min: min, max: max };
    }

    function isNativePriceServerFiltered() {
      if (!canUseNativePriceFilter) return false;
      if (state.priceRanges.length !== 1) return false;
      var bounds = getPriceRangeBounds(state.priceRanges[0]);
      if (!bounds) return false;

      var params = new URLSearchParams(window.location.search);
      var nativeMin = parseFloat(params.get('filter.v.price.gte') || '0');
      var nativeMaxValue = params.get('filter.v.price.lte');
      var nativeMax = nativeMaxValue === null ? Infinity : parseFloat(nativeMaxValue);
      var expectedMax = bounds.max === Infinity ? Infinity : Math.max(bounds.min, bounds.max - 0.01);

      return Math.abs(nativeMin - bounds.min) < 0.001 &&
        (nativeMax === Infinity && expectedMax === Infinity || Math.abs(nativeMax - expectedMax) < 0.001);
    }

    function getPriceRangeLabel(range) {
      if (range.min === 0) return 'Under ' + formatPriceValue(range.max);
      if (range.max === Infinity) return formatPriceValue(range.min) + ' and above';
      return formatPriceValue(range.min) + ' – ' + formatPriceValue(range.max);
    }

    function bindPriceRangeInputs() {
      if (!priceSegmentsEl) return;
      priceSegmentsEl.querySelectorAll('[data-filter-type="price-range"]').forEach(function (cb) {
        if (cb.dataset.priceBound === 'true') return;
        cb.dataset.priceBound = 'true';
        cb.addEventListener('change', function () {
          if (cb.checked) {
            priceSegmentsEl.querySelectorAll('[data-filter-type="price-range"]').forEach(function (other) {
              if (other !== cb) other.checked = false;
            });
            state.priceRanges = [cb.value];
            handleFullCatalogRequirementChange(cb);
          } else {
            state.priceRanges = [];
            handleFullCatalogRequirementChange(cb);
          }
        });
      });
    }

    function renderAccuratePriceSegments(segments) {
      if (!priceSegmentsEl || !segments.length) return;

      var validValues = segments.map(getPriceRangeValue);
      state.priceRanges = state.priceRanges.filter(function (value) {
        return validValues.indexOf(value) > -1;
      });
      priceSegmentsEl.textContent = '';

      segments.forEach(function (segment) {
        var labelText = getPriceRangeLabel(segment);
        var row = document.createElement('label');
        row.className = 'cc-price-segment';

        var label = document.createElement('span');
        label.className = 'cc-price-segment__label';
        label.textContent = labelText;

        var count = document.createElement('span');
        count.className = 'cc-price-segment__count';
        count.textContent = String(segment.count);

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'cc-price-' + SID;
        input.setAttribute('data-filter-type', 'price-range');
        input.setAttribute('data-filter-label', labelText);
        input.value = getPriceRangeValue(segment);
        input.checked = state.priceRanges.indexOf(input.value) > -1;
        input.dataset.initialCount = String(segment.count);

        row.appendChild(label);
        row.appendChild(count);
        row.appendChild(input);
        priceSegmentsEl.appendChild(row);
      });

      bindPriceRangeInputs();
    }

    function fetchCollectionProductOrder() {
      if (catalogOrderPromise) return catalogOrderPromise;

      var totalProducts = parseInt(grid.dataset.catalogProducts, 10) || parseInt(grid.dataset.totalProducts, 10) || 0;
      var pageCount = Math.min(100, Math.max(1, Math.ceil(totalProducts / 250)));
      var requests = [];

      function fetchCatalogPage(endpoint) {
        var controller = typeof AbortController === 'function' ? new AbortController() : null;
        var timeoutId = controller ? window.setTimeout(function () { controller.abort(); }, 15000) : null;
        var requestOptions = { credentials: 'same-origin' };
        if (controller) requestOptions.signal = controller.signal;

        return fetch(endpoint.toString(), requestOptions).then(function (response) {
          if (!response.ok) throw new Error('Collection order request failed: ' + response.status);
          return response.text();
        }).finally(function () {
          if (timeoutId) window.clearTimeout(timeoutId);
        });
      }

      for (var page = 1; page <= pageCount; page += 1) {
        var endpoint = new URL(window.location.pathname, window.location.origin);
        endpoint.searchParams.set('view', 'filter-catalog');
        endpoint.searchParams.set('page', String(page));
        if (state.sort === 'best-selling') endpoint.searchParams.set('sort_by', 'best-selling');
        requests.push(fetchCatalogPage(endpoint));
      }

      catalogOrderPromise = Promise.all(requests).then(function (pages) {
        var parser = new DOMParser();
        var products = [];
        pages.forEach(function (html) {
          var doc = parser.parseFromString(html, 'text/html');
          var payload = doc.querySelector('[data-cc-filter-catalog]');
          if (!payload) return;
          var pageData = JSON.parse(payload.textContent || '{}');
          (pageData.products || []).forEach(function (product) { products.push(product); });
        });
        return products;
      }).catch(function (error) {
        catalogOrderPromise = null;
        throw error;
      });

      return catalogOrderPromise;
    }

    function fetchCompleteCollectionPrices() {
      return fetchCollectionProductOrder().then(function (products) {
        return products.map(function (product) {
          return parseFloat(product.priceCents) / 100;
        }).filter(function (price) { return Number.isFinite(price); });
      });
    }

    function ensureAccuratePriceSegments() {
      if (!priceSegmentsEl || priceSegmentsAccurate) return Promise.resolve();
      if (priceCatalogPromise) return priceCatalogPromise;

      priceSegmentsEl.setAttribute('aria-busy', 'true');
      priceSegmentsEl.querySelectorAll('.cc-price-segment__count').forEach(function (count) {
        count.textContent = '…';
      });

      priceCatalogPromise = fetchCompleteCollectionPrices()
        .then(function (prices) {
          var segments = buildAdaptivePriceSegments(prices);
          if (!segments.length) throw new Error('No collection prices were returned.');
          renderAccuratePriceSegments(segments);
          priceSegmentsAccurate = true;
          updateURL();
          renderActiveTags();
        })
        .catch(function (error) {
          console.error('Could not prepare accurate price ranges:', error);
          initializePriceSegmentCounts();
        })
        .finally(function () {
          priceSegmentsEl.removeAttribute('aria-busy');
          priceCatalogPromise = null;
        });

      return priceCatalogPromise;
    }

    /* ── Accordion ──────────────────────────────────── */
    sectionRoot.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-acc]');
      if (!btn || !sectionRoot.contains(btn)) return;

      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var body = btn.nextElementSibling;
      btn.setAttribute('aria-expanded', String(!expanded));
      if (body) body.classList.toggle('cc-acc__body--open', !expanded);
      if (!expanded && btn.matches('[data-price-filter-toggle]')) ensureAccuratePriceSegments();
    });

    /* ── Mobile toggle ──────────────────────────────── */
    var mobileBtn = document.getElementById('cc-filter-toggle-' + SID);
    var sidebar = document.getElementById('cc-sidebar-' + SID);
    var filterBackdrop = sectionRoot.querySelector('.cc-filter-backdrop');
    var filterCloseButtons = sectionRoot.querySelectorAll('[data-cc-filter-close]');
    var mobileFilterApply = sidebar ? sidebar.querySelector('[data-mobile-filter-apply]') : null;
    var mobileFilterApplyLabel = sidebar ? sidebar.querySelector('[data-mobile-filter-apply-label]') : null;
    var mobileFilterClear = sidebar ? sidebar.querySelector('[data-mobile-filter-clear]') : null;
    var mobileFilterCount = mobileBtn ? mobileBtn.querySelector('[data-mobile-filter-count]') : null;
    var mobileDraftOriginal = null;
    var mobileDraftSequence = 0;

    function cloneFilterState(source) {
      return {
        sort: source.sort,
        sizes: source.sizes.slice(),
        colors: source.colors.slice(),
        intents: source.intents.slice(),
        priceRanges: source.priceRanges.slice(),
        lowestPrice: source.lowestPrice,
        onSale: source.onSale,
        discountRanges: source.discountRanges.slice()
      };
    }

    function replaceFilterState(source) {
      state.sort = source.sort;
      state.sizes = source.sizes.slice();
      state.colors = source.colors.slice();
      state.intents = source.intents.slice();
      state.priceRanges = source.priceRanges.slice();
      state.lowestPrice = source.lowestPrice;
      state.onSale = source.onSale;
      state.discountRanges = source.discountRanges.slice();
    }

    function syncFilterControlsFromState() {
      sectionRoot.querySelectorAll('[data-sort]').forEach(function (input) {
        input.checked = input.value === state.sort;
      });
      sectionRoot.querySelectorAll('[data-filter-type="size"]').forEach(function (input) {
        input.checked = state.sizes.indexOf(input.value) > -1;
      });
      sectionRoot.querySelectorAll('[data-filter-type="color"]').forEach(function (input) {
        input.checked = state.colors.indexOf(input.value) > -1;
      });
      sectionRoot.querySelectorAll('[data-filter-type="intent"]').forEach(function (input) {
        input.checked = state.intents.indexOf(input.value) > -1;
      });
      sectionRoot.querySelectorAll('[data-filter-type="price-range"]').forEach(function (input) {
        input.checked = state.priceRanges.indexOf(input.value) > -1;
      });
      sectionRoot.querySelectorAll('[data-filter-type="on-sale"]').forEach(function (input) {
        input.checked = state.onSale;
      });
      sectionRoot.querySelectorAll('[data-filter-type="discount-range"]').forEach(function (input) {
        input.checked = state.discountRanges.indexOf(input.value) > -1;
      });
    }

    function activeMobileFilterCount(source) {
      return source.sizes.length + source.colors.length + source.intents.length + source.priceRanges.length +
        (source.onSale ? 1 : 0) + source.discountRanges.length;
    }

    function updateMobileFilterBadge() {
      if (!mobileFilterCount) return;
      var count = activeMobileFilterCount(state);
      mobileFilterCount.textContent = String(count);
      mobileFilterCount.hidden = count === 0;
    }

    function mobileFiltersAreStaged() {
      return window.innerWidth <= 900 && sidebar && sidebar.classList.contains('cc-sidebar--open') && mobileDraftOriginal;
    }

    function updateMobileDraftPreview() {
      if (!mobileFilterApply || !mobileFilterApplyLabel || !mobileFiltersAreStaged()) return;
      var sequence = ++mobileDraftSequence;
      mobileFilterApply.disabled = true;
      mobileFilterApplyLabel.textContent = 'Checking products\u2026';

      getScalableFilterRecords().then(function (records) {
        if (sequence !== mobileDraftSequence || !mobileFiltersAreStaged()) return;
        var draftState = captureCatalogFilterState();
        var count = records.filter(function (record) {
          return catalogRecordMatchesState(record, draftState);
        }).length;
        mobileFilterApplyLabel.textContent = count === 1 ? 'Show 1 product' : 'Show ' + count + ' products';
        mobileFilterApply.disabled = false;
      }).catch(function () {
        if (sequence !== mobileDraftSequence || !mobileFiltersAreStaged()) return;
        mobileFilterApplyLabel.textContent = 'Show products';
        mobileFilterApply.disabled = false;
      });
    }

    function setMobileFilterOpen(open, commitDraft) {
      if (!mobileBtn || !sidebar) return;
      if (open) {
        mobileDraftOriginal = cloneFilterState(state);
      } else if (mobileDraftOriginal && !commitDraft) {
        replaceFilterState(mobileDraftOriginal);
        syncFilterControlsFromState();
      }
      mobileBtn.setAttribute('aria-expanded', String(open));
      sidebar.setAttribute('aria-hidden', String(!open));
      sidebar.classList.toggle('cc-sidebar--open', open);
      if (filterBackdrop) filterBackdrop.classList.toggle('is-open', open);
      document.body.classList.toggle('cc-filter-drawer-open', open);

      if (open) {
        var closeButton = sidebar.querySelector('[data-cc-filter-close]');
        if (closeButton) closeButton.focus();
        updateMobileDraftPreview();
      } else {
        mobileDraftOriginal = null;
        mobileDraftSequence += 1;
        mobileBtn.focus();
      }
    }

    if (mobileBtn && sidebar) {
      mobileBtn.addEventListener('click', function () {
        var open = mobileBtn.getAttribute('aria-expanded') === 'true';
        setMobileFilterOpen(!open);
      });

      filterCloseButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setMobileFilterOpen(false);
        });
      });

      if (mobileFilterClear) {
        mobileFilterClear.addEventListener('click', function () {
          state.sizes = [];
          state.colors = [];
          state.intents = [];
          state.priceRanges = [];
          state.onSale = false;
          state.discountRanges = [];
          syncFilterControlsFromState();
          updateMobileDraftPreview();
        });
      }

      if (mobileFilterApply) {
        mobileFilterApply.addEventListener('click', function () {
          var applyTrigger = mobileFilterApply;
          setMobileFilterOpen(false, true);
          updateMobileFilterBadge();
          handleFullCatalogRequirementChange(applyTrigger, true);
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && mobileBtn.getAttribute('aria-expanded') === 'true') {
          setMobileFilterOpen(false);
        }
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth > 900) {
          mobileBtn.setAttribute('aria-expanded', 'false');
          sidebar.removeAttribute('aria-hidden');
          sidebar.classList.remove('cc-sidebar--open');
          if (filterBackdrop) filterBackdrop.classList.remove('is-open');
          document.body.classList.remove('cc-filter-drawer-open');
          mobileDraftOriginal = null;
          mobileDraftSequence += 1;
        }
      });
    }

    /* ── Sort ───────────────────────────────────────── */
    document.querySelectorAll('[data-sort]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) {
          state.sort = radio.value;
          catalogOrderPromise = null;
          catalogFilterRecordsPromise = null;
          handleFullCatalogRequirementChange(radio);
        }
      });
    });

    /* ── Size / Color checkboxes ─────────────────────── */
    grid
      .closest('.cc-page')
      .querySelectorAll('[data-filter-type="size"]')
      .forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (cb.checked) {
            state.sizes.push(cb.value);
          } else {
            state.sizes = state.sizes.filter(function (s) {
              return s !== cb.value;
            });
          }
          handleFullCatalogRequirementChange(cb);
        });
      });

    grid
      .closest('.cc-page')
      .querySelectorAll('[data-filter-type="color"]')
      .forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (cb.checked) {
            state.colors.push(cb.value);
          } else {
            state.colors = state.colors.filter(function (c) {
              return c !== cb.value;
            });
          }
          handleFullCatalogRequirementChange(cb);
        });
      });

    grid
      .closest('.cc-page')
      .querySelectorAll('[data-filter-type="intent"]')
      .forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (cb.checked) {
            state.intents.push(cb.value);
          } else {
            state.intents = state.intents.filter(function (intent) {
              return intent !== cb.value;
            });
          }
          handleFullCatalogRequirementChange(cb);
        });
      });

    /* ── Price Range segments ───────────────────────── */
    bindPriceRangeInputs();

    /* ── Core filter + sort function ─────────────────── */
    /* Offers: load the remaining collection cards before applying offer filters. */
    grid
      .closest('.cc-page')
      .querySelectorAll('[data-filter-type="on-sale"]')
      .forEach(function (cb) {
        cb.addEventListener('change', function () {
          state.onSale = cb.checked;
          handleFullCatalogRequirementChange(cb);
        });
      });

    grid
      .closest('.cc-page')
      .querySelectorAll('[data-filter-type="discount-range"]')
      .forEach(function (cb) {
        cb.addEventListener('change', function () {
          if (cb.checked) {
            grid.closest('.cc-page').querySelectorAll('[data-filter-type="discount-range"]').forEach(function (other) {
              if (other !== cb) other.checked = false;
            });
            state.discountRanges = [cb.value];
          } else {
            state.discountRanges = [];
          }
          handleFullCatalogRequirementChange(cb);
        });
      });

    function requiresFullCatalogData() {
      return serverRenderedNativePriceFilter ||
        state.sizes.length > 0 ||
        state.colors.length > 0 ||
        state.intents.length > 0 ||
        state.priceRanges.length > 0 ||
        state.onSale ||
        state.discountRanges.length > 0 ||
        state.sort !== 'featured';
    }

    function getLoadedProductCards() {
      return cards.filter(function (card) { return !card.dataset.promo; });
    }

    function initializePriceSegmentCounts() {
      var totalProducts = parseInt(grid.dataset.catalogProducts, 10) || parseInt(grid.dataset.totalProducts, 10) || 0;
      grid.closest('.cc-page').querySelectorAll('[data-filter-type="price-range"]').forEach(function (input) {
        var segment = input.closest('.cc-price-segment');
        var countEl = segment ? segment.querySelector('.cc-price-segment__count') : null;
        if (!countEl) return;
        var serverCount = parseInt(countEl.textContent, 10) || 0;
        var safeCount = totalProducts > 0 ? Math.min(serverCount, totalProducts) : serverCount;
        countEl.textContent = safeCount;
        input.dataset.initialCount = safeCount;
      });
    }

    function setFullCatalogLoading(isLoading) {
      grid.classList.toggle('cc-grid--filter-loading', isLoading);
      grid.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      sectionRoot.classList.toggle('cc-page--filter-loading', isLoading);
      if (filterProgressEl) filterProgressEl.hidden = !isLoading;

      if (isLoading) {
        if (resultEl) resultEl.textContent = 'Updating results\u2026';
        if (sidebarCountEl) sidebarCountEl.textContent = 'Updating products\u2026';
        if (loadMoreWrap) loadMoreWrap.hidden = true;
      }
    }

    var filterInteractionSequence = 0;

    function captureFilterInteraction(triggerElement) {
      var control = triggerElement && typeof triggerElement.focus === 'function'
        ? triggerElement
        : document.activeElement;

      return {
        control: control && sectionRoot.contains(control) ? control : null,
        sidebarScrollTop: sidebar ? sidebar.scrollTop : 0
      };
    }

    function restoreFilterInteraction(interaction) {
      if (!interaction) return;

      window.requestAnimationFrame(function () {
        var control = interaction.control;
        var mobileDrawerOpen = sidebar && sidebar.classList.contains('cc-sidebar--open');

        if (mobileDrawerOpen) sidebar.scrollTop = interaction.sidebarScrollTop;
        if (!control || !control.isConnected) return;

        control.focus({ preventScroll: true });

        var rect = control.getBoundingClientRect();
        var topBoundary = mobileDrawerOpen ? 72 : 88;
        var bottomBoundary = window.innerHeight - 20;
        if (rect.top < topBoundary || rect.bottom > bottomBoundary) {
          control.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }
      });
    }

    var resultsAlignmentTimer = 0;

    function alignFirstProductRow(interactionSequence) {
      window.clearTimeout(resultsAlignmentTimer);
      resultsAlignmentTimer = window.setTimeout(function () {
        if (interactionSequence !== filterInteractionSequence || !grid || !grid.isConnected) return;

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (interactionSequence !== filterInteractionSequence || !grid.isConnected) return;

            var headerSection = document.querySelector('.header-section');
            var headerHeight = headerSection ? headerSection.getBoundingClientRect().height : 0;
            var targetTop = window.scrollY + grid.getBoundingClientRect().top - headerHeight - 16;
            var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            window.scrollTo({
              top: Math.max(0, targetTop),
              behavior: reducedMotion ? 'auto' : 'smooth'
            });
          });
        });
      }, 80);
    }

    function handleFullCatalogRequirementChange(triggerElement, forceApply) {
      if (!forceApply && triggerElement && mobileFiltersAreStaged()) {
        updateMobileDraftPreview();
        return;
      }
      var interactionSequence = ++filterInteractionSequence;
      var interaction = captureFilterInteraction(triggerElement);

      if (requiresFullCatalogData()) {
        setFullCatalogLoading(true);

        // Keep the current product grid in place while the complete collection
        // is prepared. Rendering a partial result here can collapse the page and
        // move the customer's viewport to the footer.
        renderActiveTags();
        updateURL();

        var filterPreparationFailed = false;
        loadAllProductCardsForFilter(interactionSequence).catch(function (error) {
          filterPreparationFailed = true;
          console.error('Collection filters could not be prepared:', error);
        }).finally(function () {
          if (interactionSequence !== filterInteractionSequence) return;
          setFullCatalogLoading(false);
          if (filterPreparationFailed) {
            if (resultEl) resultEl.textContent = 'Filters could not load. Please try again.';
            if (sidebarCountEl) sidebarCountEl.textContent = 'Please try again';
            if (loadMoreStatus) loadMoreStatus.textContent = 'The product list is unchanged.';
          } else {
            applyFilters();
          }
          restoreFilterInteraction(interaction);
          alignFirstProductRow(interactionSequence);
        });
      } else {
        setFullCatalogLoading(false);
        scalableFilterMode = false;
        scalableFilterRecords = [];
        scalableFilterVisibleCount = 0;
        scalableFilterInitialFillPending = false;
        removeTemporaryFilterCards();
        applyFilters();
        getScalableFilterRecords().then(function (records) {
          if (interactionSequence !== filterInteractionSequence) return;
          updateContextualPriceSegmentCounts(records, captureCatalogFilterState());
        }).catch(function (error) {
          console.warn('Price filter counts could not be refreshed:', error);
        });
        restoreFilterInteraction(interaction);
        alignFirstProductRow(interactionSequence);
      }
      updateMobileFilterBadge();
    }

    function applyFilters() {
      // Product cards can be inserted asynchronously from the lightweight
      // filter catalogue. Always rebuild the working set from the grid before
      // filtering so a card re-used from the cache cannot be present in the
      // DOM but missing from the stale `cards` array (which left every matched
      // card hidden on mobile after applying a filter).
      cards = Array.from(grid.querySelectorAll(':scope > .cc-card-wrap'));

      var scalableVisibleIds = null;
      var scalableOrder = null;
      if (scalableFilterMode) {
        scalableVisibleIds = Object.create(null);
        scalableOrder = Object.create(null);
        scalableFilterRecords.slice(0, scalableFilterVisibleCount).forEach(function (record, index) {
          scalableVisibleIds[record.id] = true;
          scalableOrder[record.id] = index;
        });
      }

      var visible = cards.filter(function (card) {
        if (card.dataset.promo) return true;
        // Scalable mode has already evaluated every active filter against the
        // complete catalogue record. Product-card endpoint markup can omit
        // filter-only data attributes (for example `data-on-sale`), so applying
        // the card predicates again would incorrectly hide valid matches.
        if (scalableVisibleIds) return !!scalableVisibleIds[getCardProductId(card)];

        /* offers */
        if (state.onSale && card.dataset.onSale !== 'true') return false;

        if (state.discountRanges.length > 0) {
          var discount = parseFloat(card.dataset.discountPercent || '0') || 0;
          var inDiscountRange = state.discountRanges.some(function (range) {
            if (range === 'upto-10') return discount > 0 && discount <= 10;
            if (range === '11-20') return discount > 10 && discount <= 20;
            if (range === '20-plus') return discount > 20;
            return false;
          });
          if (!inDiscountRange) return false;
        }

        /* price */
        var rawPrice = card.dataset.price || '0';
        var price = parseFloat(rawPrice.toString().replace(/[^0-9.]/g, '')) || 0;
        if (state.priceRanges.length > 0) {
          var inRange = state.priceRanges.some(function (r) {
            var bounds = r.split('-');
            var rMin = parseFloat(bounds[0]) * 100;
            var rMax = bounds[1] === 'plus' ? Infinity : parseFloat(bounds[1]) * 100;
            return price >= rMin && price < rMax;
          });
          if (!inRange) return false;
        }

        /* size */
        if (state.sizes.length > 0) {
          var cardSizes = card.dataset.sizes || '';
          var hasSize = state.sizes.some(function (s) {
            return cardSizes.indexOf('|' + s + '|') > -1 || cardSizes.indexOf(s + '|') === 0;
          });
          if (!hasSize) return false;
        }

        /* color */
        if (state.colors.length > 0) {
          var cardColors = card.dataset.colors || '';
          var hasColor = state.colors.some(function (c) {
            return cardColors.toLowerCase().indexOf(c.toLowerCase()) > -1;
          });
          if (!hasColor) return false;
        }

        /* executive desk buyer intent */
        if (state.intents.length > 0) {
          var cardTags = (card.dataset.tags || '').split('|');
          var hasIntent = state.intents.some(function (intent) {
            return cardTags.indexOf(intent) > -1;
          });
          if (!hasIntent) return false;
        }

        return true;
      });

      /* Sort & Interleave */
      var products = visible.filter(function (c) { return !c.dataset.promo; });
      var promos = visible.filter(function (c) { return !!c.dataset.promo; });

      products.sort(function (a, b) {
        if (scalableOrder) {
          return scalableOrder[getCardProductId(a)] - scalableOrder[getCardProductId(b)];
        }
        var priceA = parseFloat((a.dataset.price || '0').toString().replace(/[^0-9.]/g, '')) || 0;
        var priceB = parseFloat((b.dataset.price || '0').toString().replace(/[^0-9.]/g, '')) || 0;

        if (state.sort === 'price-asc') {
          return priceA - priceB;
        } else if (state.sort === 'price-desc') {
          return priceB - priceA;
        } else if (state.sort === 'title-asc') {
          return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        } else if (state.sort === 'title-desc') {
          return (b.dataset.title || '').localeCompare(a.dataset.title || '');
        } else if (state.sort === 'newest') {
          return (parseFloat(b.dataset.date) || 0) - (parseFloat(a.dataset.date) || 0);
        } else if (state.sort === 'discount-desc') {
          return (parseFloat(b.dataset.discountPercent || '0') || 0) - (parseFloat(a.dataset.discountPercent || '0') || 0);
        }
        return 0;
      });

      // Insert the compact benefit strip only after a complete group of products.
      var sorted = [];
      var pIdx = 0;
      var mIdx = 0;
      var promoInterval = window.innerWidth <= 500 ? 4 : window.innerWidth <= 900 ? 6 : 8;
      while (pIdx < products.length || mIdx < promos.length) {
        if (mIdx < promos.length && (pIdx >= promoInterval || pIdx >= products.length)) {
          sorted.push(promos[mIdx++]);
        } else if (pIdx < products.length) {
          sorted.push(products[pIdx++]);
        } else {
          break;
        }
      }

      /* Hide all, then show sorted */
      cards.forEach(function (c) {
        c.classList.add('cc-hidden');
        grid.appendChild(c);
      });
      sorted.forEach(function (c) {
        c.classList.remove('cc-hidden');
        grid.insertBefore(c, grid.querySelector('.cc-empty'));
      });

      /* Empty state */
      if (emptyMsg) emptyMsg.hidden = scalableFilterMode ? scalableFilterRecords.length > 0 : products.length > 0;

      /* Count */
      var hasActiveFilters = state.sizes.length > 0 || state.colors.length > 0 || state.intents.length > 0 || state.priceRanges.length > 0 || state.lowestPrice || state.onSale || state.discountRanges.length > 0;
      var totalProducts = parseInt(grid.dataset.totalProducts, 10) || 0;
      var hasOnlyNativePriceFilter = isNativePriceServerFiltered() &&
        state.sizes.length === 0 &&
        state.colors.length === 0 &&
        state.intents.length === 0 &&
        !state.onSale &&
        state.discountRanges.length === 0;
      var count = scalableFilterMode
        ? scalableFilterRecords.length
        : hasOnlyNativePriceFilter
          ? (totalProducts || products.length)
          : hasActiveFilters ? products.length : (totalProducts || products.length);

      if (resultEl) resultEl.textContent = count === 1 ? '1 result' : count + ' results';
      // Sidebar count should match visible results, not total cached cards
      if (sidebarCountEl) sidebarCountEl.textContent = count === 1 ? '1 item' : count + ' items';
      if (loadMoreWrap) {
        loadMoreWrap.hidden = scalableFilterMode
          ? scalableFilterVisibleCount >= scalableFilterRecords.length
          : requiresFullCatalogData();
        if (scalableFilterMode && loadMoreStatus) {
          var remaining = Math.max(0, scalableFilterRecords.length - scalableFilterVisibleCount);
          var preparingCount = Math.max(0, getScalableInitialVisibleCount(scalableFilterRecords.length) - scalableFilterVisibleCount);
          loadMoreStatus.textContent = scalableFilterInitialFillPending && preparingCount > 0
            ? 'Showing ' + scalableFilterVisibleCount + ' of ' + scalableFilterRecords.length + ' products. Preparing the next ' + preparingCount + '.'
            : remaining > 0
              ? 'Showing ' + scalableFilterVisibleCount + ' of ' + scalableFilterRecords.length + ' products.'
              : 'All ' + scalableFilterRecords.length + ' matching products are shown.';
        }
      }

      /* Active tags */
      renderActiveTags();

      /* Update URL */
      updateURL();
    }

    /* ── Active filter tags ──────────────────────────── */
    function renderActiveTags() {
      if (!activeEl) return;
      activeEl.innerHTML = '';

      if (
        state.sizes.length > 0 ||
        state.colors.length > 0 ||
        state.intents.length > 0 ||
        state.priceRanges.length > 0 ||
        state.lowestPrice ||
        state.onSale ||
        state.discountRanges.length > 0
      ) {
        var clearBtn = document.createElement('button');
        clearBtn.id = 'cc-clear-' + SID;
        clearBtn.className = 'cc-clear-all';
        clearBtn.textContent = 'Clear all';
        clearBtn.addEventListener('click', clearAll);
        activeEl.appendChild(clearBtn);
      }

      state.sizes.forEach(function (s) {
        activeEl.appendChild(
          makeTag('Size: ' + s, function () {
            state.sizes = state.sizes.filter(function (x) {
              return x !== s;
            });
            grid
              .closest('.cc-page')
              .querySelectorAll('[data-filter-type="size"]')
              .forEach(function (cb) {
                if (cb.value === s) cb.checked = false;
              });
            handleFullCatalogRequirementChange();
          })
        );
      });

      state.colors.forEach(function (c) {
        activeEl.appendChild(
          makeTag('Color: ' + c, function () {
            state.colors = state.colors.filter(function (x) {
              return x !== c;
            });
            grid
              .closest('.cc-page')
              .querySelectorAll('[data-filter-type="color"]')
              .forEach(function (cb) {
                if (cb.value === c) cb.checked = false;
              });
            handleFullCatalogRequirementChange();
          })
        );
      });

      var intentLabels = {
        'Executive Desk: Compact': 'Compact',
        'Executive Desk: With Cabinet': 'With cabinet',
        'Executive Desk: Luxury': 'Luxury',
        'Executive Desk: Director': 'Director',
        'Executive Desk: Height Adjustable': 'Height adjustable'
      };
      state.intents.forEach(function (intent) {
        activeEl.appendChild(
          makeTag('Desk type: ' + (intentLabels[intent] || intent), function () {
            state.intents = state.intents.filter(function (value) { return value !== intent; });
            grid.closest('.cc-page').querySelectorAll('[data-filter-type="intent"]').forEach(function (cb) {
              if (cb.value === intent) cb.checked = false;
            });
            handleFullCatalogRequirementChange();
          })
        );
      });

      state.priceRanges.forEach(function (r) {
        var priceInput = grid
          .closest('.cc-page')
          .querySelector('[data-filter-type="price-range"][value="' + CSS.escape(r) + '"]');
        var label = priceInput && priceInput.dataset.filterLabel
          ? priceInput.dataset.filterLabel
          : currency_symbol + r.replace('-', ' – ').replace('plus', 'and above');
        activeEl.appendChild(
          makeTag('Price: ' + label, function () {
            state.priceRanges = state.priceRanges.filter(function (x) {
              return x !== r;
            });
            grid
              .closest('.cc-page')
              .querySelectorAll('[data-filter-type="price-range"]')
              .forEach(function (cb) {
                if (cb.value === r) cb.checked = false;
              });
            handleFullCatalogRequirementChange();
          })
        );
      });

      if (state.onSale) {
        activeEl.appendChild(
          makeTag('On sale', function () {
            state.onSale = false;
            grid
              .closest('.cc-page')
              .querySelectorAll('[data-filter-type="on-sale"]')
              .forEach(function (cb) {
                cb.checked = false;
              });
            handleFullCatalogRequirementChange();
          })
        );
      }

      var discountLabels = {
        'upto-10': 'Up to 10%',
        '11-20': '11%–20%',
        '20-plus': 'More than 20%'
      };
      state.discountRanges.forEach(function (range) {
        activeEl.appendChild(
          makeTag('Discount: ' + discountLabels[range], function () {
            state.discountRanges = state.discountRanges.filter(function (value) { return value !== range; });
            grid.closest('.cc-page').querySelectorAll('[data-filter-type="discount-range"]').forEach(function (cb) {
              if (cb.value === range) cb.checked = false;
            });
            handleFullCatalogRequirementChange();
          })
        );
      });

    }

    function makeTag(text, onRemove) {
      var tag = document.createElement('button');
      tag.type = 'button';
      tag.className = 'cc-filter-tag';
      tag.innerHTML = text + ' &times;';
      tag.setAttribute('aria-label', 'Remove ' + text + ' filter');
      tag.addEventListener('click', onRemove);
      return tag;
    }

    function clearAll() {
      state.sizes = [];
      state.colors = [];
      state.intents = [];
      state.priceRanges = [];
      state.onSale = false;
      state.discountRanges = [];
      grid
        .closest('.cc-page')
        .querySelectorAll('[data-filter-type="size"],[data-filter-type="color"],[data-filter-type="intent"],[data-filter-type="price-range"],[data-filter-type="on-sale"],[data-filter-type="discount-range"]')
        .forEach(function (cb) {
          cb.checked = false;
        });
      handleFullCatalogRequirementChange();
    }

    function initScrollSlider(type, sid) {
      var track = document.getElementById('cc-' + type + '-track-' + sid);
      var prev = document.getElementById('cc-' + type + '-prev-' + sid);
      var next = document.getElementById('cc-' + type + '-next-' + sid);
      if (!track || !prev || !next) return;

      var step = function () {
        var first = track.firstElementChild;
        return first ? first.offsetWidth + 12 : 160;
      };

      prev.onclick = function () {
        track.scrollBy({ left: -step() * 2, behavior: 'smooth' });
      };
      next.onclick = function () {
        track.scrollBy({ left: step() * 2, behavior: 'smooth' });
      };

      var update = function () {
        if (track.scrollLeft <= 5) prev.classList.remove('is-visible');
        else prev.classList.add('is-visible');

        if (track.scrollLeft + track.offsetWidth >= track.scrollWidth - 5) next.classList.remove('is-visible');
        else next.classList.add('is-visible');
      };

      track.onscroll = update;
      window.addEventListener('resize', update);
      setTimeout(update, 200);
    }

    /* ── Infinite scroll (section fetch) ── */
    var loadMoreEl = document.getElementById('cc-load-more-' + SID);
    var loadMoreWrap = document.getElementById('cc-load-more-wrap-' + SID);
    var loadMoreLabel = loadMoreEl ? loadMoreEl.querySelector('.cc-load-more-button__label') : null;
    var loadMoreStatus = document.getElementById('cc-load-more-status-' + SID);
    var scrollLoading = false;
    var prefetchedBatch = null;
    var prefetchPromise = null;
    var scalableFilterMode = false;
    var scalableFilterRecords = [];
    var scalableFilterVisibleCount = 0;
    var scalableFilterInitialFillPending = false;
    var catalogFilterRecordsPromise = null;
    var catalogCardPromises = Object.create(null);
    var catalogCardCache = Object.create(null);

    function getCardProductId(card) {
      var productCard = card ? card.querySelector('product-card[data-product-id]') : null;
      return productCard ? String(productCard.getAttribute('data-product-id') || '') : '';
    }

    cards.forEach(function (card) {
      var productId = getCardProductId(card);
      if (productId) catalogCardCache[productId] = card;
    });

    function captureCatalogFilterState() {
      return {
        sort: state.sort,
        sizes: state.sizes.slice(),
        colors: state.colors.slice(),
        intents: state.intents.slice(),
        priceRanges: state.priceRanges.slice(),
        onSale: state.onSale,
        discountRanges: state.discountRanges.slice()
      };
    }

    function catalogRecordMatchesState(record, filterState) {
      if (filterState.onSale && !record.onSale) return false;

      if (filterState.discountRanges.length > 0) {
        var matchesDiscount = filterState.discountRanges.some(function (range) {
          if (range === 'upto-10') return record.discount > 0 && record.discount <= 10;
          if (range === '11-20') return record.discount > 10 && record.discount <= 20;
          if (range === '20-plus') return record.discount > 20;
          return false;
        });
        if (!matchesDiscount) return false;
      }

      if (filterState.priceRanges.length > 0) {
        var matchesPrice = filterState.priceRanges.some(function (value) {
          var bounds = getPriceRangeBounds(value);
          return bounds && record.price >= bounds.min && record.price < bounds.max;
        });
        if (!matchesPrice) return false;
      }

      if (filterState.sizes.length > 0) {
        var matchesSize = filterState.sizes.some(function (size) {
          return record.sizes.indexOf(size) > -1;
        });
        if (!matchesSize) return false;
      }

      if (filterState.colors.length > 0) {
        var lowerColors = record.colors.map(function (color) { return String(color).toLowerCase(); });
        var matchesColor = filterState.colors.some(function (color) {
          return lowerColors.indexOf(String(color).toLowerCase()) > -1;
        });
        if (!matchesColor) return false;
      }

      if (filterState.intents.length > 0) {
        var recordTags = record.tags || [];
        var matchesIntent = filterState.intents.some(function (intent) {
          return recordTags.indexOf(intent) > -1;
        });
        if (!matchesIntent) return false;
      }

      return true;
    }

    function sortCatalogFilterRecords(records, filterState) {
      return records.sort(function (a, b) {
        if (filterState.sort === 'price-asc') return a.price - b.price;
        if (filterState.sort === 'price-desc') return b.price - a.price;
        if (filterState.sort === 'title-asc') return a.title.localeCompare(b.title);
        if (filterState.sort === 'title-desc') return b.title.localeCompare(a.title);
        if (filterState.sort === 'newest') return b.date - a.date;
        if (filterState.sort === 'discount-desc') return b.discount - a.discount;
        return a.position - b.position;
      });
    }

    function updateContextualPriceSegmentCounts(records, filterState) {
      if (!priceSegmentsEl || !records) return;

      // Facet counts must reflect every active filter except the Price facet
      // itself. For example, after selecting On sale, each price row reports
      // only sale products that fall inside that price range.
      var contextState = {
        sort: filterState.sort,
        sizes: filterState.sizes.slice(),
        colors: filterState.colors.slice(),
        intents: filterState.intents.slice(),
        priceRanges: [],
        onSale: filterState.onSale,
        discountRanges: filterState.discountRanges.slice()
      };
      var contextualRecords = records.filter(function (record) {
        return catalogRecordMatchesState(record, contextState);
      });

      priceSegmentsEl.querySelectorAll('[data-filter-type="price-range"]').forEach(function (input) {
        var bounds = getPriceRangeBounds(input.value);
        var segment = input.closest('.cc-price-segment');
        var countEl = segment ? segment.querySelector('.cc-price-segment__count') : null;
        if (!bounds || !countEl) return;

        var count = contextualRecords.reduce(function (total, record) {
          return total + (record.price >= bounds.min && record.price < bounds.max ? 1 : 0);
        }, 0);
        countEl.textContent = String(count);
        segment.classList.toggle('is-unavailable', count === 0 && !input.checked);
        input.disabled = count === 0 && !input.checked;
      });
    }

    function fetchCatalogCard(record) {
      if (catalogCardCache[record.id]) return Promise.resolve(catalogCardCache[record.id]);
      if (catalogCardPromises[record.id]) return catalogCardPromises[record.id];

      var endpoint = new URL('/products/' + encodeURIComponent(record.handle), window.location.origin);
      endpoint.searchParams.set('view', 'card');
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timeoutId = controller ? window.setTimeout(function () { controller.abort(); }, 15000) : null;
      var requestOptions = { credentials: 'same-origin' };
      if (controller) requestOptions.signal = controller.signal;

      catalogCardPromises[record.id] = fetch(endpoint.toString(), requestOptions)
        .then(function (response) {
          if (!response.ok) throw new Error('Product card request failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var card = doc.querySelector('.cc-card-wrap');
          if (!card) throw new Error('Product card markup was not returned for ' + record.handle);
          catalogCardCache[record.id] = card;
          return card;
        })
        .catch(function (error) {
          delete catalogCardPromises[record.id];
          throw error;
        })
        .finally(function () {
          if (timeoutId) window.clearTimeout(timeoutId);
        });

      return catalogCardPromises[record.id];
    }

    function ensureCatalogCards(records, insertCards) {
      var cursor = 0;
      var failures = [];
      var workerCount = Math.min(4, records.length);

      function fetchNextCard() {
        if (cursor >= records.length) return Promise.resolve();
        var record = records[cursor++];
        return fetchCatalogCard(record).catch(function (error) {
          failures.push({ record: record, error: error });
        }).then(fetchNextCard);
      }

      var workers = [];
      for (var workerIndex = 0; workerIndex < workerCount; workerIndex += 1) {
        workers.push(fetchNextCard());
      }

      return Promise.all(workers).then(function () {
        if (failures.length) {
          console.warn('Some matching product cards could not be prepared:', failures);
        }
        if (insertCards === false) return failures;
        records.forEach(function (record) {
          var card = catalogCardCache[record.id];
          if (!card || grid.contains(card)) return;
          card.classList.add('cc-filter-temporary');
          grid.insertBefore(card, emptyMsg);
          if (cards.indexOf(card) === -1) cards.push(card);
        });
        return failures;
      });
    }

    function getScalableFilterRecords() {
      if (catalogFilterRecordsPromise) return catalogFilterRecordsPromise;
      catalogFilterRecordsPromise = fetchCollectionProductOrder().then(function (products) {
        return products.map(function (product, index) {
          var price = (parseFloat(product.priceCents) || 0) / 100;
          var compareAt = (parseFloat(product.compareAtCents) || 0) / 100;
          var onSale = compareAt > price;
          return {
            id: String(product.id),
            handle: product.handle || '',
            title: product.title || '',
            date: parseFloat(product.date) || 0,
            price: price,
            onSale: onSale,
            discount: onSale ? Math.round((compareAt - price) * 100 / compareAt) : 0,
            sizes: product.sizes || [],
            colors: product.colors || [],
            tags: product.tags || [],
            position: index
          };
        });
      }).catch(function (error) {
        catalogFilterRecordsPromise = null;
        throw error;
      });
      return catalogFilterRecordsPromise;
    }

    function getScalableInitialVisibleCount(total) {
      var preferredCount = window.innerWidth <= 500 ? 8 : 12;
      return Math.min(preferredCount, total);
    }

    function prepareScalableFilterResults(interactionSequence) {
      var filterState = captureCatalogFilterState();
      return getScalableFilterRecords().then(function (records) {
        if (interactionSequence !== filterInteractionSequence) return false;
        updateContextualPriceSegmentCounts(records, filterState);
        var nextRecords = sortCatalogFilterRecords(records.filter(function (record) {
          return catalogRecordMatchesState(record, filterState);
        }), filterState);
        var initialVisibleCount = getScalableInitialVisibleCount(nextRecords.length);
        var fastVisibleCount = Math.min(4, initialVisibleCount);

        return ensureCatalogCards(nextRecords.slice(0, fastVisibleCount), false).then(function () {
          if (interactionSequence !== filterInteractionSequence) return false;
          removeTemporaryFilterCards();
          scalableFilterMode = true;
          scalableFilterRecords = nextRecords;
          scalableFilterVisibleCount = fastVisibleCount;
          scalableFilterInitialFillPending = initialVisibleCount > fastVisibleCount;
          return ensureCatalogCards(nextRecords.slice(0, fastVisibleCount), true).then(function () {
            if (scalableFilterInitialFillPending) {
              ensureCatalogCards(nextRecords.slice(fastVisibleCount, initialVisibleCount), false).then(function () {
                if (interactionSequence !== filterInteractionSequence || scalableFilterVisibleCount !== fastVisibleCount) return;
                scalableFilterVisibleCount = initialVisibleCount;
                scalableFilterInitialFillPending = false;
                return ensureCatalogCards(nextRecords.slice(0, initialVisibleCount), true).then(function () {
                  if (interactionSequence === filterInteractionSequence) applyFilters();
                });
              }).catch(function (error) {
                if (interactionSequence !== filterInteractionSequence) return;
                scalableFilterInitialFillPending = false;
                console.warn('The initial matching product set could not be completed:', error);
                applyFilters();
              });
            }
            return true;
          });
        });
      });
    }

    function loadNextScalableFilterBatch() {
      if (scrollLoading || !scalableFilterMode) return;
      scalableFilterInitialFillPending = false;
      var nextCount = Math.min(scalableFilterVisibleCount + 24, scalableFilterRecords.length);
      if (nextCount <= scalableFilterVisibleCount) return;

      scrollLoading = true;
      loadMoreEl.disabled = true;
      loadMoreEl.classList.add('is-loading');
      if (loadMoreLabel) loadMoreLabel.textContent = 'Loading products';
      if (loadMoreStatus) loadMoreStatus.textContent = 'Adding matching products.';

      ensureCatalogCards(scalableFilterRecords.slice(0, nextCount)).then(function () {
        scalableFilterVisibleCount = nextCount;
        applyFilters();
        loadMoreEl.disabled = false;
        loadMoreEl.classList.remove('is-loading');
        if (loadMoreLabel) loadMoreLabel.textContent = 'Load more products';
      }).catch(function (error) {
        console.error('Error loading matching products:', error);
        loadMoreEl.disabled = false;
        loadMoreEl.classList.remove('is-loading');
        if (loadMoreLabel) loadMoreLabel.textContent = 'Try loading again';
        if (loadMoreStatus) loadMoreStatus.textContent = 'Matching products could not be loaded. Please try again.';
      }).finally(function () {
        scrollLoading = false;
      });
    }

    function getSectionUrl(url) {
      var sectionUrl = new URL(url, window.location.origin);
      sectionUrl.searchParams.set('section_id', SID);
      return sectionUrl.toString();
    }

    function fetchProductPage(url) {
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timeoutId = controller ? window.setTimeout(function () { controller.abort(); }, 15000) : null;
      var requestOptions = { credentials: 'same-origin' };
      if (controller) requestOptions.signal = controller.signal;

      return fetch(getSectionUrl(url), requestOptions)
        .then(function (res) {
          if (!res.ok) throw new Error('Product page request failed: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('cc-grid-' + SID);
          var nextButton = doc.getElementById('cc-load-more-' + SID);
          return {
            cards: newGrid ? Array.from(newGrid.querySelectorAll('.cc-card-wrap')) : [],
            nextUrl: nextButton ? nextButton.getAttribute('data-url') || '' : ''
          };
        })
        .finally(function () {
          if (timeoutId) window.clearTimeout(timeoutId);
        });
    }

    function prefetchNextBatch() {
      if (scalableFilterMode || requiresFullCatalogData()) return Promise.resolve(null);
      if (prefetchPromise || prefetchedBatch || !loadMoreEl) return prefetchPromise;
      var firstUrl = loadMoreEl.getAttribute('data-url');
      if (!firstUrl || firstUrl === 'null') return Promise.resolve(null);

      prefetchPromise = fetchProductPage(firstUrl)
        .then(function (firstPage) {
          if (!firstPage.nextUrl || firstPage.cards.length >= 24) return firstPage;
          return fetchProductPage(firstPage.nextUrl).then(function (secondPage) {
            return {
              cards: firstPage.cards.concat(secondPage.cards).slice(0, 24),
              nextUrl: secondPage.nextUrl
            };
          });
        })
        .then(function (batch) {
          prefetchedBatch = batch;
          if (loadMoreStatus && batch && batch.cards.length && !scalableFilterMode && !requiresFullCatalogData()) {
            loadMoreStatus.textContent = batch.cards.length + ' products ready to view.';
          }
          return batch;
        })
        .catch(function (err) {
          console.error('Error preparing more products:', err);
          if (loadMoreStatus) loadMoreStatus.textContent = 'More products will load when requested.';
          return null;
        })
        .finally(function () {
          prefetchPromise = null;
        });
      return prefetchPromise;
    }

    function loadAllProductCardsForFilter(interactionSequence) {
      // Use the lightweight catalog index for every collection architecture.
      // The old aggregated-collection path fetched every paginated product card
      // before showing a result, which made combined filters feel frozen. This
      // path finds all matches from compact catalog data and renders only the
      // first visible batch; the next products remain available via Load more.
      return prepareScalableFilterResults(interactionSequence);
    }

    function removeTemporaryFilterCards() {
      cards = cards.filter(function (card) {
        if (!card.classList.contains('cc-filter-temporary')) return true;
        card.remove();
        return false;
      });
      if (loadMoreWrap) loadMoreWrap.hidden = requiresFullCatalogData();
    }

    function loadMoreCards() {
      if (scalableFilterMode) {
        loadNextScalableFilterBatch();
        return;
      }
      if (scrollLoading || !loadMoreEl || !loadMoreWrap || !loadMoreWrap.parentNode) return;
      scrollLoading = true;
      loadMoreEl.disabled = true;
      loadMoreEl.classList.add('is-loading');
      if (loadMoreLabel) loadMoreLabel.textContent = 'Loading products';
      if (loadMoreStatus) loadMoreStatus.textContent = 'Adding the next products to this collection.';

      Promise.resolve(prefetchedBatch || prefetchNextBatch()).then(function (batch) {
        if (!batch || !batch.cards.length) throw new Error('No additional product cards returned.');
        batch.cards.forEach(function (card) {
          grid.insertBefore(card, emptyMsg);
          cards.push(card);
        });
        prefetchedBatch = null;
        if (batch.nextUrl) {
          loadMoreEl.setAttribute('data-url', batch.nextUrl);
          loadMoreEl.disabled = false;
          loadMoreEl.classList.remove('is-loading');
          if (loadMoreLabel) loadMoreLabel.textContent = 'Load more products';
          if (loadMoreStatus) loadMoreStatus.textContent = 'Next products are being prepared.';
          prefetchNextBatch();
        } else {
          loadMoreWrap.remove();
        }
        applyFilters();
      }).catch(function (err) {
        console.error('Error loading more products:', err);
        loadMoreEl.disabled = false;
        loadMoreEl.classList.remove('is-loading');
        if (loadMoreLabel) loadMoreLabel.textContent = 'Try loading again';
        if (loadMoreStatus) loadMoreStatus.textContent = 'Products could not be loaded. Please try again.';
      }).finally(function () {
        scrollLoading = false;
      });
    }

    if (loadMoreWrap && loadMoreEl) {
      loadMoreEl.addEventListener('click', loadMoreCards);
      // Warm the compact filter index before prefetching the heavier next-card
      // batch. This makes the customer's first filter interaction responsive
      // without sacrificing the instant Load more experience afterwards.
      window.setTimeout(function () {
        getScalableFilterRecords()
          .catch(function (error) {
            console.warn('Collection filter index could not be prefetched:', error);
          })
          .finally(prefetchNextBatch);
      }, 150);
    }

    /* Initial render */
    syncStateFromDOM();
    syncStateFromURL();
    serverRenderedNativePriceFilter = isNativePriceServerFiltered();
    initializePriceSegmentCounts();
    var initialPricePreparation = state.priceRanges.length > 0
      ? ensureAccuratePriceSegments()
      : Promise.resolve();
    initialPricePreparation.finally(function () {
      if (requiresFullCatalogData()) handleFullCatalogRequirementChange();
      else applyFilters();
      updateMobileFilterBadge();
    });

    var activePromoInterval = window.innerWidth <= 500 ? 4 : window.innerWidth <= 900 ? 6 : 8;
    window.addEventListener('resize', function () {
      var nextPromoInterval = window.innerWidth <= 500 ? 4 : window.innerWidth <= 900 ? 6 : 8;
      if (nextPromoInterval !== activePromoInterval) {
        activePromoInterval = nextPromoInterval;
        applyFilters();
      }
    });

    window.addEventListener('popstate', function () {
      state.sort = defaultSort;
      state.sizes = [];
      state.colors = [];
      state.intents = [];
      state.priceRanges = [];
      state.lowestPrice = false;
      state.onSale = false;
      state.discountRanges = [];
      scalableFilterMode = false;
      scalableFilterRecords = [];
      scalableFilterVisibleCount = 0;
      scalableFilterInitialFillPending = false;
      removeTemporaryFilterCards();

      grid
        .closest('.cc-page')
        .querySelectorAll('[data-sort], [data-filter-type]')
        .forEach(function (control) {
          control.checked = control.matches('[data-sort][value="' + defaultSort + '"]');
        });

      syncStateFromURL();
      if (requiresFullCatalogData()) handleFullCatalogRequirementChange();
      else applyFilters();
    });

    initScrollSlider('sub', SID);
    initScrollSlider('rel', SID);
    initScrollSlider('rel-top', SID);
  })();
  /* ── Variant Thumbs: Show More / Less ───────────────────────── */
  (function () {
    function initThumbCollapse(card) {
      var wrap = card.querySelector('[data-thumb-wrap]');
      var toggle = card.querySelector('[data-thumb-toggle]');
      if (!wrap || !toggle) return;

      var thumbs = Array.from(wrap.querySelectorAll('.cc-card__thumb'));
      if (thumbs.length === 0) return;

      function collapse() {
        /* Reset first */
        thumbs.forEach(function (t) { t.classList.remove('cc-card__thumb--hidden'); });
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        var more = toggle.querySelector('.cc-thumbs-toggle__more');
        var less = toggle.querySelector('.cc-thumbs-toggle__less');
        if (more) more.hidden = false;
        if (less) less.hidden = true;

        /* Measure on next frame to ensure layout is ready */
        requestAnimationFrame(function() {
          if (thumbs.length === 0) return;
          var firstTop = thumbs[0].getBoundingClientRect().top;
          var cutIndex = -1;
          for (var i = 1; i < thumbs.length; i++) {
            if (Math.round(thumbs[i].getBoundingClientRect().top) > Math.round(firstTop) + 4) {
              cutIndex = i;
              break;
            }
          }

          if (cutIndex === -1) return; /* All thumbs fit in one row */

          /* Hide excess thumbs */
          for (var j = cutIndex; j < thumbs.length; j++) {
            thumbs[j].classList.add('cc-card__thumb--hidden');
          }
          var hiddenCount = thumbs.length - cutIndex;
          toggle.hidden = false;
          var moreLabel = toggle.querySelector('.cc-thumbs-more-label');
          if (moreLabel) moreLabel.textContent = '+' + hiddenCount + ' more';
        });
      }

      collapse();

      var optionsDetails = card.querySelector('.cc-card__options');
      if (optionsDetails) {
        optionsDetails.addEventListener('toggle', function () {
          if (optionsDetails.open) {
            requestAnimationFrame(collapse);
          }
        });
      }

      toggle.onclick = function (e) {
        e.preventDefault(); e.stopPropagation();
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var more = toggle.querySelector('.cc-thumbs-toggle__more');
        var less = toggle.querySelector('.cc-thumbs-toggle__less');
        if (!expanded) {
          /* Show all */
          thumbs.forEach(function (t) { t.classList.remove('cc-card__thumb--hidden'); });
          toggle.setAttribute('aria-expanded', 'true');
          if (more) more.hidden = true;
          if (less) less.hidden = false;
        } else {
          /* Collapse back to one row */
          collapse();
        }
      };
    }

    function initAllThumbs() {
      document.querySelectorAll('.cc-card--premium').forEach(function (card) {
        if (!card.dataset.thumbInit) {
          card.dataset.thumbInit = '1';
          initThumbCollapse(card);
        }
      });
    }

    document.addEventListener('DOMContentLoaded', initAllThumbs);
    window.addEventListener('resize', function() {
       document.querySelectorAll('.cc-card--premium').forEach(function(c) {
          if (c.querySelector('[data-thumb-toggle]')?.getAttribute('aria-expanded') !== 'true') {
             delete c.dataset.thumbInit;
          }
       });
       initAllThumbs();
    });
    document.addEventListener('shopify:section:load', initAllThumbs);
    window.addEventListener('load', initAllThumbs);
    setTimeout(initAllThumbs, 1000);
    setTimeout(initAllThumbs, 3000);
  })();
